export default __webpack_public_path__ + "static/media/visa.4203cfc2.webp";